import { defineAsyncComponent } from 'vue'
import { defineNuxtPlugin } from '#app'

const components = {}

export default defineNuxtPlugin(nuxtApp => {
  for (const name in components) {
    nuxtApp.vueApp.component(name, components[name])
    nuxtApp.vueApp.component('Lazy' + name, components[name])
  }
})
